import { render, staticRenderFns } from "./ConferenceDates.vue?vue&type=template&id=55529b56&"
import script from "./ConferenceDates.vue?vue&type=script&lang=js&"
export * from "./ConferenceDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports